import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/modules/growing-circle/lib/api";
import { identifyConsentedUser, resetConsentedIdentity } from "@/modules/growing-circle/lib/posthogIdentity";
import { setUser as setConsentedHistoryUser } from "@/lib/consented-history";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      // Consented-only PostHog identify — the helper itself refuses
      // when iubenda Measurement consent (purpose 4) is absent.
      try {
        if (typeof window !== "undefined") {
          window.__sdCachedCircleUser = data;
          identifyConsentedUser(data);
          setConsentedHistoryUser(data);
        }
      } catch { /* noop */ }
    } catch {
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
    try {
      if (typeof window !== "undefined") delete window.__sdCachedCircleUser;
      resetConsentedIdentity();
      setConsentedHistoryUser(null);
    } catch { /* noop */ }
  };

  const isListener = user && ["admin", "author", "facilitator"].includes(user.role);
  const isAdmin = user && user.role === "admin";

  return (
    <AuthContext.Provider value={{ user, setUser, ready, refresh, logout, isListener, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
